module.exports = __webpack_public_path__ + "static/img/4.4c4850c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/delivery/4.png
// module id = wioL
// module chunks = 1